// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"DriverAccidentTab_buttonContainer__3S83X"};